import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { applyTheme } from "./lib/theme.js";
import { registerSW } from "virtual:pwa-register";
import "./styles/global.css";

// Apply the persisted theme before first paint to avoid a flash.
const stored = localStorage.getItem("lingoloco_theme");
applyTheme(stored === "light" || stored === "dark" || stored === "system" ? stored : "system");

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service worker registration. autoUpdate + runtimeUpdateMode from the PWA
// plugin: the shell is pre-cached and /api/* is NetworkOnly. We deliberately
// do NOT force a reload mid-session; the update prompt is surfaced via the
// plugin's default behavior (next navigation).
registerSW({ immediate: true });
